"use client";

import Image from "next/image";
import { useState } from "react";
import { ImageOff } from "lucide-react";

/**
 * Imagen de producto optimizada (Next redimensiona + webp — sin
 * `unoptimized`, que servía el original pesado). Muestra un skeleton
 * animado mientras descarga y hace fade-in al cargar; cae a un ícono si no
 * hay imagen o falla. Se usa con un contenedor `relative` (aspect-square).
 */
export default function ProductImage({
  src,
  alt,
  sizes,
  className = "",
  priority = false,
  iconSize = 28,
}: {
  src: string | null;
  alt: string;
  sizes: string;
  className?: string;
  priority?: boolean;
  iconSize?: number;
}) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  if (!src || errored) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-shell">
        <ImageOff size={iconSize} className="text-dark/20" />
      </div>
    );
  }

  return (
    <>
      {!loaded && (
        <div className="absolute inset-0 animate-pulse bg-muted/25" aria-hidden />
      )}
      <Image
        src={src}
        alt={alt}
        fill
        sizes={sizes}
        quality={70}
        priority={priority}
        onLoad={() => setLoaded(true)}
        onError={() => setErrored(true)}
        className={`object-cover transition-[opacity,transform] duration-500 ${
          loaded ? "opacity-100" : "opacity-0"
        } ${className}`}
      />
    </>
  );
}
